// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISourceTransactorActorDto
 */
export interface ISourceTransactorActorDto {
    /**
     * 
     * @type {number}
     * @memberof ISourceTransactorActorDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ISourceTransactorActorDto
     */
    transactor_actor_type?: ISourceTransactorActorDtoTransactorActorTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ISourceTransactorActorDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ISourceTransactorActorDto
     */
    contact_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ISourceTransactorActorDto
     */
    tech_user_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ISourceTransactorActorDto
     */
    organization_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ISourceTransactorActorDto
     */
    card_processor_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ISourceTransactorActorDto
     */
    card_acceptor_id?: string;
    /**
     * 
     * @type {number}
     * @memberof ISourceTransactorActorDto
     */
    provider_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ISourceTransactorActorDto
     */
    vendor_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum ISourceTransactorActorDtoTransactorActorTypeEnum {
    SYSTEM = 'SYSTEM',
    EMPLOYEE = 'EMPLOYEE',
    ADMIN = 'ADMIN',
    ORGANIZATION = 'ORGANIZATION',
    CARD_PROCESSOR = 'CARD_PROCESSOR',
    CARD_ACCEPTOR = 'CARD_ACCEPTOR',
    PROVIDER = 'PROVIDER',
    VENDOR = 'VENDOR'
}


/**
 * Check if a given object implements the ISourceTransactorActorDto interface.
 */
export function instanceOfISourceTransactorActorDto(value: object): value is ISourceTransactorActorDto {
    return true;
}

export function ISourceTransactorActorDtoFromJSON(json: any): ISourceTransactorActorDto {
    return ISourceTransactorActorDtoFromJSONTyped(json, false);
}

export function ISourceTransactorActorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISourceTransactorActorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'transactor_actor_type': json['transactor_actor_type'] == null ? undefined : json['transactor_actor_type'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'tech_user_id': json['tech_user_id'] == null ? undefined : json['tech_user_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'card_processor_id': json['card_processor_id'] == null ? undefined : json['card_processor_id'],
        'card_acceptor_id': json['card_acceptor_id'] == null ? undefined : json['card_acceptor_id'],
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'vendor_id': json['vendor_id'] == null ? undefined : json['vendor_id'],
    };
}

export function ISourceTransactorActorDtoToJSON(json: any): ISourceTransactorActorDto {
    return ISourceTransactorActorDtoToJSONTyped(json, false);
}

export function ISourceTransactorActorDtoToJSONTyped(value?: ISourceTransactorActorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'transactor_actor_type': value['transactor_actor_type'],
        'employee_id': value['employee_id'],
        'contact_id': value['contact_id'],
        'tech_user_id': value['tech_user_id'],
        'organization_id': value['organization_id'],
        'card_processor_id': value['card_processor_id'],
        'card_acceptor_id': value['card_acceptor_id'],
        'provider_id': value['provider_id'],
        'vendor_id': value['vendor_id'],
    };
}

